module.exports = __webpack_public_path__ + "media/images/version_merge/steps_loan_payment-b4ac646497c7e0240a7b720a6c5cba68.jpg";